import { EvidenceExceptionType } from '../shared/evidence.exception.tag';
import { EvidenceEnforcement } from './evidence.enforcement';
import { TaskEvidenceKind } from './task.evidence';

const EVIDENCE_EXCEPTION_TYPE_BY_KIND: Record<TaskEvidenceKind, EvidenceExceptionType> = {
    beforePhoto: EvidenceExceptionType.Photo,
    duringPhoto: EvidenceExceptionType.Photo,
    afterPhoto: EvidenceExceptionType.Photo,
    file: EvidenceExceptionType.File,
    form: EvidenceExceptionType.Form,
    signature: EvidenceExceptionType.Signature,
    comment: EvidenceExceptionType.Comment,
};

export function toEvidenceExceptionType(kind: TaskEvidenceKind): EvidenceExceptionType {

    return EVIDENCE_EXCEPTION_TYPE_BY_KIND[kind];
}

/** Only Required (allow exceptions) evidence of a type the exception explained when recorded; one stored without `explainedTypes` explains nothing, so a malformed row fails closed. */
export function isEvidenceExplained(exception: { explainedTypes?: EvidenceExceptionType[] } | null | undefined, shortfall: { kind: TaskEvidenceKind; level: EvidenceEnforcement }): boolean {

    return shortfall.level === EvidenceEnforcement.RequiredExceptionAllowed && !!exception?.explainedTypes?.includes(toEvidenceExceptionType(shortfall.kind));
}
